import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['SortMobilePopupStyles-cvaRoot', 'fixed z-[100] left-0 top-0', 'w-full h-full']);

export const cvaOverlay = cva([
  'SortMobilePopupStyles-cvaOverlay',
  'absolute left-0 top-0 ',
  'w-full h-full',
  'bg-cBlack32',
]);

export const cvaClose = cva([
  'ReviewPopupStyles-cvaClose',
  'flex items-center justify-center',
  'absolute top-1.2 right-2.4',
  'w-2.4 h-2.4',
  'cursor-pointer select-none',
]);

export const cvaCloseIcon = cva(['ReviewPopupStyles-cvaCloseIcon', 'w-2.4 h-2.4', 'fill-cBlack']);

export const cvaHeader = cva([
  'SortMobilePopupStyles-cvaHeader',
  'relative',
  'p-1.4',
  'w-full',
  'text-center text-labelL uppercase',
  'bg-cLightGrey',
  'rounded-tl-[2rem] rounded-tr-[2rem]',
]);

export const cvaInner = cva([
  'SortMobilePopupStyles-cvaInner',
  'flex flex-col',
  'fixed bottom-0 left-0',
  'w-full',
  'bg-cWhite',
  'rounded-tl-[2rem] rounded-tr-[2rem]',
]);

export const cvaBody = cva(['SortMobilePopupStyles-cvaBody', 'overflow-auto', 'flex-grow', 'w-full', 'py-3.2 px-2.4']);
